<template>
    <v-navigation-drawer app v-model="drawer" v-if="isLoggedIn">
        <p class="text-center mb-2">
            <router-link :to="{name: 'Home' }">
                <img
                    src="/img/fancom-logo.svg"
                    height="50"
                />
            </router-link>
        </p>
        <v-list
            nav
        >
            <v-list-item
                v-for="item in items"
                :key="item.title"
                :to="{name: item.route}"
                :exact="item.exact"
                link
            >
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list dense>
            <v-list-item
                @click.prevent.stop="toggleLanguageList"
                :aria-expanded="showLanguageList ? 'true' : 'false'"
                link
            >
                <v-list-item-action>
                    <v-icon small>fal fa-language</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Language</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-progress-circular
                        v-if="isUpdatingLanguage"
                        indeterminate
                        size="16"
                        width="2"
                    ></v-progress-circular>
                    <v-icon v-else small color="accent">
                        {{ showLanguageList ? 'fal fa-angle-up' : 'fal fa-angle-down' }}
                    </v-icon>
                </v-list-item-action>
            </v-list-item>
            <v-slide-y-transition>
                <div v-show="showLanguageList" class="navigation-drawer-language-list">
                    <v-list-item
                        v-for="lang in languages"
                        :key="lang.value"
                        @click.stop="selectLanguage(lang.value)"
                        dense
                        link
                    >
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ lang.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon v-if="user && isLanguagePreferred(lang.value)" small color="accent">fal fa-check</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </div>
            </v-slide-y-transition>
        </v-list>
        <div class="bottom mt-auto">
            <v-btn v-if="!user.externalAuth" outlined color="accent" small @click="onClickPasswordChangeButton" class="mb-3">
                <v-icon
                    small
                    left
                >
                    fal fa-key
                </v-icon>
                Change password
            </v-btn>
            <v-btn color="primary" @click="onClickLogoutButton">
                <v-icon
                    small
                    left
                >
                    fal fa-sign-out
                </v-icon>
                Logout
            </v-btn>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapState} from 'vuex';
import languages from '@/enums/languages';

export default {
    name: "NavigationDrawer",
    data: () => ({
        appVersion: process.env.VUE_APP_VERSION,
        isUpdatingLanguage: false,
        languages: languages,
        showLanguageList: false,
    }),
    computed: {
        drawer: {
            get() {
                return this.$store.state.app.drawer
            },
            set(value) {
                this.$store.dispatch('toggleNavigationDrawer', value);
            }
        },
        ...mapState({
            items: state => state.app.navigationItems,
            isLoggedIn: state => state.auth.isLoggedIn,
            user: state => state.auth.user
        })
    },
    methods: {
        onClickPasswordChangeButton() {
            this.$router.push({name:'ChangePassword'});
        },
        onClickLogoutButton() {
            this.$emit('show-logout-dialog', true)
        },
        toggleLanguageList() {
            if (this.isUpdatingLanguage) {
                return;
            }
            this.showLanguageList = !this.showLanguageList;
        },
        selectLanguage(value) {
            var currentLanguages = (this.user && Array.isArray(this.user.languages)) ? this.user.languages.slice() : [];
            var index = currentLanguages.indexOf(value);

            if (index > -1) {
                currentLanguages.splice(index, 1);
            } else {
                currentLanguages.push(value);
            }

            this.isUpdatingLanguage = true;
            this.$store.dispatch('changeLanguages', { languages: currentLanguages })
                .then(function(ok) {
                    if (ok) {
                        this.$store.dispatch('showSnackbar', { text: 'Languages updated' });
                    }
                }.bind(this))
                .catch(function() {
                    this.$store.dispatch('showSnackbar', { text: 'Could not update languages', color: 'error' });
                }.bind(this))
                .finally(function() {
                    this.isUpdatingLanguage = false;
                }.bind(this));
        },
        isLanguagePreferred(lang) {
            if (!this.user || !this.user.languages) {
                return false;
            }
            return Array.isArray(this.user.languages) ? this.user.languages.includes(lang) : this.user.languages === lang;
        }
    }
}
</script>

<style scoped>

</style>
